type AssetOperation = {
  label: string
  target:
    | {
        type: "program"
        program: number | string
      }
    | {
        type: "film"
        film: number
      }
  operation: string
  args: any
  files?: File[]
  onComplete?: () => void
}

class AssetOperationManager {
  queue: AssetOperation[] = []
  currentOperation: AssetOperation | null = null

  private subscribers: ((self: AssetOperationManager) => void)[] = []

  addOperation(args: AssetOperation) {
    this.queue.push(args)
    if (!this.currentOperation) {
      this.nextOperation()
    }
  }

  async nextOperation() {
    if (this.queue.length === 0) return

    const args = this.queue.shift()!
    try {
      this.currentOperation = args
      this.notify()
      await this.performAssetOp(args)
    } catch (e) {
      console.error("Error performing asset operation", e)
    } finally {
      this.currentOperation = null
      this.nextOperation()
      this.notify()
    }
  }

  subscribe(callback: (self: AssetOperationManager) => void) {
    this.subscribers.push(callback)

    callback(this)

    return () => {
      this.subscribers = this.subscribers.filter((cb) => cb !== callback)
    }
  }

  notify() {
    for (const cb of this.subscribers) {
      cb(this)
    }
  }

  private async performAssetOp(args: AssetOperation) {
    console.log("Perform operation", args)
    const url =
      args.target.type === "film"
        ? `/wp-json/sff/v1/assets/film/${args.target.film}/${args.operation}`
        : `/wp-json/sff/v1/assets/program/${args.target.program}/${args.operation}`

    const headers = new Headers()
    const data = new FormData()
    for (const file of args.files ?? []) {
      data.append("files[]", file)
    }
    data.append("args", JSON.stringify(args.args))
    headers.append("Content-Type", "multipart/form-data")
    await fetch(url, {
      method: "POST",
      body: data,
    })
    if (args.onComplete) {
      args.onComplete()
    }
  }
}

export const assetManager = new AssetOperationManager()
